export const VEHICLE_TYPE = {
  CAR: 'CAR',
  MOTORCYCLE: 'MOTORCYCLE',
} as const

/** 차량 연료 타입 (staple) */
export const FUEL_TYPE = {
  PREMIUM_GASOLINE: '0', // 고급 휘발유
  GASOLINE: '1', // 일반 휘발유
  DIESEL: '2', // 경유
  LPG: '3', // LPG
  EV: '4', // 전기
} as const

export const CAR_NUMBER_INPUT_MAX_LENGTH = 9 as const
